// Optional birthday, stored as "MM-DD" (month + day only — never the year, so it
// can't reveal age). Opt-in; absent/null when not set. Drives the birthday frame
// shown on a person's Top 8 tile (and the widget) on their birthday.

export const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

// Days in a month, using a leap year so Feb 29 is selectable.
export function daysInMonth(monthIndex /* 0-11 */) {
  return new Date(2024, monthIndex + 1, 0).getDate();
}

// "MM-DD" from 1-based month + day, or null if either is missing.
export function toMMDD(month, day) {
  if (!month || !day) return null;
  return `${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

// Parse "MM-DD" -> { month, day } (1-based), or null.
export function parseMMDD(mmdd) {
  if (typeof mmdd !== 'string' || !/^\d{2}-\d{2}$/.test(mmdd)) return null;
  const [m, d] = mmdd.split('-').map(Number);
  if (m < 1 || m > 12 || d < 1 || d > 31) return null;
  return { month: m, day: d };
}

// Is the given "MM-DD" today, in the viewer's local time?
export function isBirthdayToday(mmdd) {
  const parsed = parseMMDD(mmdd);
  if (!parsed) return false;
  const now = new Date();
  return parsed.month === now.getMonth() + 1 && parsed.day === now.getDate();
}

// "March 4" style label for display.
export function formatBirthday(mmdd) {
  const parsed = parseMMDD(mmdd);
  if (!parsed) return '';
  return `${MONTHS[parsed.month - 1]} ${parsed.day}`;
}
